<template>
  <div>
    <Grid @api="getTransfers()"
          :headers="headers"
          :payload="{results, count, next, previous}"
          @filter="showFilterModal = true"
          @clearFilters="$refs.desktopFilters.reset()">
      <template #head.actions>
        <span class="bg-secondary"></span>
      </template>

      <template #filter>
        <TransfersFilters ref="desktopFilters" />
      </template>

      <template #body.created_at="{item}">
        {{ item.created_at ? $d(new Date(item.created_at), 'long') : '-' }}
      </template>
      <template #body.actions="{item}">
        <BaseButtonIcon
          @click="getTransferKeys(item)"
          tooltip="Keys"
          class="bg-secondary-light"
          :loading="fetched === item[pk]"
          :icon="visibleTransfers.includes(item[pk]) ? `expand-up` : `expand-down`"
        />
      </template>

      <template #expanded="{item}">
        <transition name="slidedown" class="slidedown transition-all">
          <div v-if="visibleTransfers.includes(item[pk]) && fetched === 0">
            <div class="grid-expanded">
              <div class="flex flex-wrap items-center content-around text-sm text-gray-700">
                <div class="flex flex-col" v-for="(device, i) in item.devices_list" :key="i">
                  <div class="mx-3 shadow bg-white p-2 my-2 lg:my-3">
                    {{ device }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </template>
    </Grid>

    <!-- Mobile filters -->
    <transition v-if="showFilterModal" name="grow">
      <base-modal @close="showFilterModal = false" head="filters" bg="white" full-width>
        <TransfersFilters :mobile="true" ref="mobileFilter" />
        <!-- Action buttons -->
        <div class="pt-4 mt-6 border-t flex flex-col justify-end w-full">
          <div class="flex flex-col">
            <div class="flex space-x-4">
              <base-button
                class="w-1/2"
                @click="
                  $refs.mobileFilter.reset()
                  showFilterModal = false
                "
                action="clear"
                context="secondary"
              >
                <base-icon icon="close" />
              </base-button>
              <base-button
                class="w-1/2"
                @click="
                  $refs.mobileFilter.submit()
                  showFilterModal = false
                "
                action="submit"
              >
                <base-icon icon="filters" />
              </base-button>
            </div>
          </div>
        </div>
      </base-modal>
    </transition>
  </div>
</template>

<script>
import Grid from '@/components/shared/Grid.vue'
import TransfersFilters from "./TransfersFilters.vue";
import {BaseButtonIcon, BaseModal, BaseIcon, BaseButton} from '@/components/base'

export default {
  components: {
    Grid,
    BaseIcon,
    BaseButton,
    BaseModal,
    BaseButtonIcon,
    TransfersFilters
  },
  data() {
    return {
      list: {},
      pk: 'id',
      visibleTransfers: [],
      fetched: 0,
      headers: {
        company_from_name: {
          label: 'company_from_name',
          order: false,
        },
        company_to_name: {
          label: 'company_to_name',
          order: false,
        },
        created_at: {
          label: 'created',
          order: true,
        },
        actions: {
          label: '',
          order: false,
          className: 'lg:w-20',
        },
      },
      showFilterModal: false
    }
  },
  computed: {
    count() {
      return this.list && this.list.count ? this.list.count : 0
    },
    next() {
      return this.list && this.list.next ? this.list.next : null
    },
    previous() {
      return this.list && this.list.previous ? this.list.previous : null
    },
    results() {
      return this.list && this.list.results ? this.list.results : []
    },
  },
  methods: {
    async getTransfers() {
      try {
        this.list = await this.$store.dispatch('keys/getTransfers')
      } catch (error) {}
    },
    getTransferKeys(record) {
      const id = record[this.pk]
      if (!this.visibleTransfers.includes(id)) {
        const foundIndex = this.list.results.findIndex(transfer => transfer[this.pk] === id)
        if (!this.list.results[foundIndex].devices_list) {
          this.fetched = id
          this.$store
            .dispatch('keys/getTransferKeys', id)
            .then(data => {
              this.list.results[foundIndex] = Object.assign({}, this.list.results[foundIndex], data)
              this.fetched = 0
            })
            .catch()
        }
        return this.visibleTransfers.push(id)
      }
      return this.visibleTransfers.splice(this.visibleTransfers.indexOf(id), 1)
    },
  },
}
</script>
